/* eslint-disable */
import Api from '@/services/Api'

export default {
    getAll(prevId, prevDate, limit, search){
        try {
            console.log("Interaction GetAll");

            return Api().get('interaction/all/?prev_id='+prevId+'&prev_date='+prevDate+'&limit='+limit+'&search='+search);
        }catch(err){
            console.log(err);
            return err
        }
    },

    adminAll(prevId, prevDate, limit, search, adminId){
        try {
            console.log("Regular Admin Interaction GetAll");
            return Api().get('interaction/admin/?prev_id='+prevId+'&prev_date='+prevDate+'&limit='+limit+'&search='+search+'&admin_id='+adminId.Int64);
        }catch(err){
            console.log(err);
            return err
        }
    }
}
